export default "__VITE_ASSET__CFQSSCCK__"